import { WalmartOffer } from 'pages/loyalty/loyalty-partners/walmart/walmart-offer';

export default function Partnerships() {
  return <WalmartOffer />;
}
